module.exports = __webpack_public_path__ + "static/media/blur-background.25dbc0e3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/blur-background.jpg
 ** module id = 880
 ** module chunks = 0
 **/